import React, { useState, useEffect } from 'react';
import {
  buyerNeedsPhoneVerificationSelector,
  buyerSelector,
  createdAccountSelector,
  modifiedPasswordSelector,
  setupAuthOngoingSelector,
} from '../../features/auth';
import { useAppSelector, useWidgetsTheme as theme } from '../../core/hooks';
import Login from './Login';
import Signup from './Signup';
import ForgotPassword from './ForgotPassword';
import { Spinner } from '@src/components/reusable';
import styled from 'styled-components';
import PhoneVerificationForm from '@src/components/Account/PhoneVerification';
import { LayoutColors } from '@src/core/theme';

export const LOGIN = 'login';
export const SIGNUP = 'signup';
export const PHONE = 'phone';
export const FORGOT_PASSWORD = 'forgot_password';

export type CurrentModePageTypes = 'checkout' | 'account';

interface AuthDisplayProps {
  onLogin?: () => void;
  hasBackAction?: boolean;
}

const AuthDisplay = (props: AuthDisplayProps) => {
  const { onLogin, hasBackAction = false } = props;
  const actionColor = theme('actionColor');
  const [loading, setLoading] = useState(true);

  const [_, logged] = useAppSelector(buyerSelector);
  const needsPhoneVerification = useAppSelector(buyerNeedsPhoneVerificationSelector);
  const accountCreated = useAppSelector(createdAccountSelector);
  const modifiedPassword = useAppSelector(modifiedPasswordSelector);
  const setupAuthOngoing = useAppSelector(setupAuthOngoingSelector);
  const [mode, setMode] = useState(LOGIN);

  useEffect(() => {
    if (logged && onLogin && !needsPhoneVerification) {
      onLogin();
    }

    if (logged && needsPhoneVerification) {
      setMode(PHONE);
    }

    if (mode && !setupAuthOngoing && loading) {
      setLoading(false);
    }
  }, [logged, accountCreated, modifiedPassword, setupAuthOngoing, needsPhoneVerification]);

  if (loading) {
    return (
      <SpinnerWrapper>
        <Spinner visible spinnerColor={actionColor} />
      </SpinnerWrapper>
    );
  }

  return (
    <div>
      <div>
        {(() => {
          switch (mode) {
            case LOGIN:
              return <Login setMode={setMode} hasBackAction={hasBackAction} />;
            case FORGOT_PASSWORD:
              return <ForgotPassword onBack={() => setMode(LOGIN)} />;
            case SIGNUP:
              return <Signup setMode={setMode} />;
            case PHONE:
              return (
                <PhoneVerificationWrapper>
                  <PhoneVerificationContent>
                    <PhoneVerificationForm showBackButton={false} />
                  </PhoneVerificationContent>
                </PhoneVerificationWrapper>
              );
            default:
              return null;
          }
        })()}
      </div>
    </div>
  );
};

const SpinnerWrapper = styled.div`
  width: 100px;
  height: 100px;
  margin: 0 auto;
`;

const PhoneVerificationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const PhoneVerificationContent = styled.div`
  max-width: 800px;
  background: ${LayoutColors.whiteDark};
  padding: 40px;
`;

export default AuthDisplay;
